var _g, _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgYoutubePlay = function SvgYoutubePlay(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 72,
    height: 72,
    fill: "none",
    viewBox: "0 0 72 72"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#E7ECF1",
    d: "M32.195 27.75A1.44 1.44 0 0 0 30 28.978v14.046a1.44 1.44 0 0 0 2.195 1.226l11.412-7.023a1.44 1.44 0 0 0 0-2.453z"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 71.28,
    height: 71.28,
    x: 0.36,
    y: 0.36,
    stroke: "#E7ECF1",
    strokeWidth: 0.72,
    rx: 35.64
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M21.6 21.6h28.8v28.8H21.6z"
  })))));
};
export default SvgYoutubePlay;